export default __webpack_public_path__ + "media/workspace.a925c827.webp";